import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessInstanceHistory } from './process-instance-history';
export { ProcessInstanceHistory };
import { processInstanceHistorySchema } from '@schemas/business-objects/process-instance-history';
import { ProcessInstanceFormGroup } from './process-instance-form-group';

export class ProcessInstanceHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    processInstanceId: SchemaFormControl;
    processInstance: ProcessInstanceFormGroup;
  };

  declare value: Partial<ProcessInstanceHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processInstanceHistorySchema, ProcessInstanceHistory, data, options);
  }

  get object(): ProcessInstanceHistory {
    return new ProcessInstanceHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processInstance':
        return new ProcessInstanceFormGroup();
      default:
        return undefined;
    }
  }
}

export class ProcessInstanceHistoryFormArray extends PersistedFormArray {
  readonly entityName = 'ProcessInstanceHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processInstanceHistorySchema, ProcessInstanceHistory, options);
  }

  protected override createItemGroup() {
    return new ProcessInstanceHistoryFormGroup();
  }

  get array(): ProcessInstanceHistory[] {
    return this.controls.map(
      (group: ProcessInstanceHistoryFormGroup) => group.object,
    );
  }
}

export class ProcessInstanceHistoryPersistedArray extends PersistedArray<ProcessInstanceHistory> {
  readonly entityName = 'ProcessInstanceHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessInstanceHistory, options);
  }
}
